import React from 'react';

import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';
import { ViewSizeType } from '@types';

import { SimulationCardHeaderAb } from './simulationCardHeader.ab';
import { SimulationCardHeaderBcp } from './simulationCardHeader.bcp';

export interface SimulationCardHeaderProps {
	term: number;
	value: number;
	label?: string;
	currentView: ViewSizeType;
}

export const SimulationCardHeader: React.FC<SimulationCardHeaderProps> = (
	props: SimulationCardHeaderProps
): JSX.Element => {
	return (
		<RenderComponent
			components={{
				ab: {
					desktop: <SimulationCardHeaderAb {...props} />,
					mobile: <SimulationCardHeaderAb {...props} />,
					intranet: null,
				},
				bcp: {
					desktop: <SimulationCardHeaderBcp {...props} />,
					mobile: <SimulationCardHeaderBcp {...props} />,
					intranet: null,
				},
			}}
		/>
	);
};
